import { Layout } from 'antd';
import { FunctionComponent } from 'react';
import '../../App.css';

const { Footer } = Layout;

const footerStyle: React.CSSProperties = {
    textAlign: 'center',
    color: '#fff',
    backgroundColor: '#1a80b1',
};

const FooterPeche: FunctionComponent = () => {
    return (
        <Footer style={footerStyle}>
            Amicale des pêcheurs Ansériens de Oye-Plage
            <br />
            <br />
            <img style={{height: "200px", width: "150px"}} src="/pecheapp/LogoAssociation.jpeg" />
            <a href="https://www.facebook.com/p/Les-%C3%A9tangs-communaux-de-Oye-Plage-100047316354194/"><img style={{height: "200px", width: "200px"}} src="/pecheapp/facebookLogo.jpg" /></a>
        </Footer>
    );
}

export default FooterPeche;
